import cx from 'classnames'

import logoIcon from 'Images/logo-icon.png'

export const LoadingIndicator = ({ className, label = 'Loading', ...props }) => (
  <div
    aria-live="polite"
    className={cx(
      'tw:flex tw:min-h-[220px] tw:w-full tw:flex-col tw:items-center tw:justify-center tw:gap-3 tw:text-center',
      className,
    )}
    role="status"
    {...props}
  >
    <img
      alt=""
      aria-hidden="true"
      className="tw:h-12 tw:w-12 tw:rounded-full tw:animate-spin tw:motion-reduce:animate-none"
      src={logoIcon}
    />
    <span className="ds-label tw:text-foreground-muted">{label}</span>
  </div>
)
